/**
 * External Dependencies
 */
import 'jquery';
import 'slick-carousel'
import 'slick-carousel/slick/slick.css'

$(document).ready(() => {
  $('.slider-main').slick({
    dots: true,
    arrows: false,
    infinite: true,
    speed: 500,
    adaptiveHeight: true,
    fade: true,
    dotsClass: 'slider-main__dots',
    cssEase: 'linear'
  });

  $('.js-burger').on('click', function (){
    $(this).toggleClass('active');
    $('.js-nav-mobile').toggle();
  });

  function headerFix(){
    $(window).scroll(function (){
      let topPos = $(this).scrollTop();
      let navigation = $('.js-header');
      let navigationTop = $('.header__top').outerHeight(true);

      if($(window).innerWidth() >= '769'){
        if (topPos > navigationTop) {
          navigation.addClass('header__body--fixed')
        } else {
          navigation.removeClass('header__body--fixed')
        }
      }
    });
  }

  headerFix();

  $(window).resize(function() {
    headerFix();
  });

  let scrollTop = $(".scroll-top");

  $(window).scroll(function() {

    let topPos = $(this).scrollTop();

    if (topPos > 100) {
      $(scrollTop).css("opacity", "1");

    } else {
      $(scrollTop).css("opacity", "0");
    }

  });


  let scrollTopBtn = $(".scroll-top .scroll-top__btn");

  $(scrollTopBtn).click(function() {
    $('html, body').animate({
      scrollTop: 0
    }, 800);
    return false;

  });
});
